import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import ButtonGoToCreateUser from '@/modules/user/components/buttonGoToCreateUser/buttonGoToCreateUser';
import { USER_PERMISSIONS, USER_TYPE } from '@/modules/user/entities/user.const';
import { ROUTE_USER } from '@/modules/user/routes';
import TableAndFilterUser from '@/modules/user/views/tableAndFilterUser/tableAndFilterUser';
import ICONS from '@/shared/entities/constants/icons';
import React from 'react';
import Header from '@/core/components/header/header';

const HomeUserCompany: React.FC = () => {
  const { checkUserHasPermission } = useCurrentUser();

  return (
    <>
      <Header title='Administradores' icon={ICONS.USER}>
        <ButtonGoToCreateUser
          routeIdToDetails={ROUTE_USER.BROKER_USER_CREATE}
          disabledCreateAction={!checkUserHasPermission(USER_PERMISSIONS.BROKER_USER_CREATE)}
        />
      </Header>
      <TableAndFilterUser userType={USER_TYPE.BROKER} />
    </>
  );
};

export default HomeUserCompany;
